import { render, staticRenderFns } from "./dialogSendPurchase.vue?vue&type=template&id=0f75000b&scoped=true"
import script from "./dialogSendPurchase.vue?vue&type=script&lang=js"
export * from "./dialogSendPurchase.vue?vue&type=script&lang=js"
import style0 from "./dialogSendPurchase.vue?vue&type=style&index=0&id=0f75000b&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f75000b",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/QuotesTracking/dialogSendPurchase.vue
// module id = 2441
// module chunks = 31